import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { BreadcrumbItem } from '@dxo/ng-swift-ui/lib/components/breadcrumbs-nav/breadcrumbs-nav.types';
import { WINDOW } from '@benefitsui/app/lib/tokens/window';
import { filter, Subscription } from 'rxjs';
import { BillingListComponent } from './list/list.component';
import { BillingService } from './billing.service';
import { CellItemType } from './billing-page.types';

@Component({
  selector: 'app-billing-page',
  templateUrl: './billing-page.component.html',
  styleUrls: ['./billing-page.component.scss'],
  standalone: false
})
export class BillingPageComponent implements OnInit, OnDestroy {
  constructor(
    @Inject(WINDOW) private window: Window,
    private billingService: BillingService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  @ViewChild('listForm')
  private listForm!: BillingListComponent;
  returnPath: string = "/benefits/billing/listing";
  currentPath: string = "/benefits/billing/billing";
  links: BreadcrumbItem[] = [];
  breadcrumbs: boolean = false;
  routeDataSubscription: Subscription = new Subscription();
  
  ngOnInit(): void {
    this.routeDataSubscription = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.breadcrumbs = this.resolveData('breadcrumbs');
      });
      this.links.push({
        text: this.route.routeConfig?.data?.headerText,
        path: this.returnPath
      });
  }

  ngOnDestroy(): void {
    this.routeDataSubscription?.unsubscribe();
  }

  goPayment(selectedTable: CellItemType[]) {    
    this.navigateToChild('payment');
    this.billingService.setPayment(selectedTable);
    if (selectedTable.length > 0) {
      this.billingService.setTotalAmount(this.totalAmount());
    }
  }

  goBillingList() {    
    this.navigateToChild('listing');
  }

  goPremium(invoiceInfo: CellItemType) {
    this.navigateToChild('premium');
    this.billingService.setInvoiceData(invoiceInfo);
  }

  navigateToChild(path: string) {
    this.router.navigate([path], {relativeTo: this.route, queryParamsHandling: "preserve"});            
    this.scrollToTop();    
  }

  scrollToTop() {
    this.window.scrollTo(0, 0);
  }

  totalAmount() {
    return this.listForm.selectedItems.reduce((sum, current) => sum + current.amount, 0);
  }

  private resolveData(key: string) {
    let child = this.route.firstChild;
    while (child) {
      if (child.firstChild) {
        child = child.firstChild;
      } else if (child.snapshot.data && child.snapshot.data[key]) {
        return child.snapshot.data[key];
      } else {
        return undefined;
      }
    }
  }
}
